import * as interfaces from '../interfaces';
import { ApiService } from './api.service';
import { CookieService } from './cookie.service';

export let ClientServiceInstance: ClientService | null = null;

export function createClientServiceInstance(): void {
  if (!ClientServiceInstance) {
    ClientServiceInstance = new ClientService();
  }
}

export class ClientService extends ApiService {
  private id: string;

  constructor() {
    super();

    this.id = 'ClientService';
  }

  getClient(clientId: string): Promise<interfaces.ClientInterface> {
    const errorIdentifier = `${this.id} -> Get Client`;

    return this.get({ endpoint: 'clients', path: `/${clientId}` })
      .then((res: any) => {
        const responseData: interfaces.GeneralResponseInterface<interfaces.ClientInterface> = res.data;

        if (!responseData.data || !responseData.data.length) {
          this.reportInvalidResponseError(errorIdentifier, res);
        }

        return responseData.data[0];
      })
      .catch(err => {
        this.reportRequestError(errorIdentifier, err);

        return {} as interfaces.ClientInterface;
      });
  }

  getStoredClientSelector(): string {
    const storedClientSelector = CookieService.getLocalStorage('clientId');

    return storedClientSelector;
  }

  getStoredClient(): interfaces.ClientInterface | null {
    const storedClientRef = CookieService.getLocalStorage('client', true);

    if (storedClientRef?.id) return storedClientRef;

    return null;
  }

  storeClient(client: interfaces.ClientInterface, clientSelector: string): void {
    CookieService.setLocalStorage('client', client, true);
    CookieService.setLocalStorage('clientSelector', clientSelector);
  }
}
